import * as React from 'react';
import { RootHomeGrid } from '../app/home/RootHomeGrid';

export const HomeRoot = (): JSX.Element => {
	return (
		<div className="Root-home">
			<h2>Seleccione una aplicación:</h2>
			<RootHomeGrid />
		</div>
	);
};
